import React, { useState } from 'react';
import { Desktop, Tablet } from '../../constants/responsive';
import { css } from '@emotion/core';
import FormBand from '../../svgs/banner-band-flipped.svg';
import { FormattedHTMLMessage, useIntl } from 'gatsby-plugin-intl';
import Button from '../Button';
import Container from '../Container';
import { useAppContext } from '../../context/AppContext';
import Check from '../../svgs/check.svg';
import Success from '../../svgs/institutions/success.svg';
import Axios from 'axios';

const errorMessages = {
  en: {
    missingName: 'Please enter your name',
    missingCompany: 'Please enter your company',
    missingEmail: 'Please enter your email',
    invalidEmail: 'Invalid email',
    missingPhone: 'Please enter your phone number',
    invalidPhone: 'Invalid phone number',
  },
  'zh-cn': {
    missingName: '请输入姓名',
    missingCompany: '请输入公司',
    missingEmail: '请输入电邮',
    invalidEmail: '电邮格式错误，请重新输入',
    missingPhone: '请输入电话',
    invalidPhone: '电话格式错误，请重新输入',
  },
  'zh-hk': {
    missingName: '請輸入姓名',
    missingCompany: '請輸入公司',
    missingEmail: '請輸入電郵',
    invalidEmail: '電郵格式錯誤，請重新輸入',
    missingPhone: '請輸入電話',
    invalidPhone: '電話格式錯誤，請重新輸入',
  },
};

const Input = ({
  type = 'text',
  placeholder,
  onChange = () => {},
  errorMessage = '',
}) => {
  return (
    <div
      css={css`
        position: relative;
      `}
    >
      <input
        css={css`
          width: 100%;

          border-radius: 40px;
          padding: 0px 30px;
          background: white;
          font-weight: bold;
          color: black;
          // margin-bottom: 12px;
          &::placeholder {
            color: #b3b3b3;
            text-align: center;
            font-size: 12px;
            font-weight: 500;
            line-height: 2;
          }
          border: solid 1px #ffffff;
          height: 40px;
          ${Tablet} {
            height: 52px;
            &::placeholder {
              font-size: 18px;
              font-weight: 500;
              line-height: 1.33;
            }
          }
          ${Desktop} {
            height: 52px;
          }
        `}
        type={type}
        placeholder={placeholder}
        onChange={onChange}
      />
      <div
        css={css`
          font-size: 12px;
          line-height: 12px;
          height: 12px;
          font-weight: bold;
          color: #ff5252;
          margin-left: 30px;
          margin-bottom: 8px;
          ${Tablet} {
            margin-bottom: 12px;
          }
        `}
      >
        {errorMessage}
      </div>
    </div>
  );
};

const InstitutionsForm = () => {
  const intl = useIntl();

  const [loading, setLoading] = useState(false);

  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');

  const [company, setCompany] = useState('');
  const [companyError, setCompanyError] = useState('');

  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState('');

  const [success, setSuccess] = useState(false);

  const resetError = () => {
    setNameError('');
    setCompanyError('');
    setEmailError('');
    setPhoneError('');
  };

  const { institutionsFormRef, setErrorCode, apiUrl } = useAppContext();
  const errorMessageMap = {
    en: 'EN',
    'zh-cn': 'SC',
    'zh-hk': 'TC',
  };
  return (
    <div
      ref={institutionsFormRef}
      css={css`
        width: 100%;
        // margin-top: 80px;
        ${Desktop} {
          // margin-top: 160px;
        }
      `}
    >
      {/* <div
        css={css`
          height: 25px;
          width: 100%;
          min-width: 320px;
          * {
            fill: #003e86;
          }
          ${Tablet} {
            height: 40px;
          }
          ${Desktop} {
            height: 70px;
          }
        `}
      >
        <FormBand width='100%' height='100%' />
      </div> */}
      <div
        css={css`
          background: #004e8f;
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 604px;
          ${Tablet} {
            height: 674px;
          }
          ${Desktop} {
          }
        `}
      >
        {success ? (
          <div
            css={css`
              text-align: center;
              color: white;
              max-width: 800px;
              ${Desktop} {
              }
            `}
          >
            <Success
              css={css`
                width: 70px;
                height: 70px;
                margin-top: 217px;
                margin-bottom: 30px;
                ${Tablet} {
                  width: 117px;
                  height: 117px;
                  margin-top: 181px;
                  margin-bottom: 40px;
                }
                ${Desktop} {
                  width: 117px;
                  height: 117px;
                  margin-top: 178px;
                  margin-bottom: 50px;
                }
              `}
            />
            <div
              css={css`
                // margin-bottom: 40px;
                text-align: center;
                font-size: 18px;
                font-weight: bold;
                line-height: 1.44;
                ${Tablet} {
                  font-size: 36px;
                  font-weight: bold;
                  line-height: 1.39;
                }
                ${Desktop} {
                  font-size: 40px;
                  font-weight: bold;
                  line-height: 1.13;
                }
                display: block;
              `}
            >
              {
                {
                  en: (
                    <span>
                      Thank you for contacting us.
                      <br />
                      We will be in touch with you shortly.
                    </span>
                  ),
                  'zh-cn': (
                    <span>
                      提交成功，感谢你的支持，
                      <br />
                      我们会尽快与你联系
                    </span>
                  ),
                  'zh-hk': (
                    <span>
                      提交成功，感謝你的支持，
                      <br />
                      我們會盡快與你聯繫
                    </span>
                  ),
                }[intl.locale]
              }
            </div>
          </div>
        ) : (
          <>
            <span
              css={css`
                color: #ffffff;
                text-align: center;
                font-weight: bold;

                font-size: 26px;
                line-height: 1.73;
                margin-top: 75.1px;
                ${Tablet} {
                  font-size: 40px;
                  line-height: 1.13;
                  margin-top: 103.1px;
                }
                ${Desktop} {
                  font-size: 40px;
                  line-height: 1.13;
                  margin-top: 50px;
                }
              `}
            >
              <FormattedHTMLMessage id='institutions.form.title' />
            </span>
            <div
              css={css`
                text-align: center;
                color: white;
                font-weight: 500;

                font-size: 14px;
                line-height: 1.14;
                margin-top: 4.1px;
                margin-bottom: 22.8px;
                ${Tablet} {
                  font-size: 18px;
                  line-height: 1.33;
                  margin-top: 12.2px;
                  margin-bottom: 45.7px;
                }
                ${Desktop} {
                  font-size: 18px;
                  line-height: 1.33;
                  margin-top: 12.2px;
                  margin-bottom: 45.7px;
                }
              `}
            >
              <FormattedHTMLMessage id='institutions.form.before-email' />
              <br
                css={css`
                  display: block;
                  ${Tablet} {
                    display: none;
                  }
                `}
              />
              aqumon-icg@magnumwm.com
            </div>
            <div
              css={css`
                width: 100%;
                // padding: 0px 20px;
                max-width: 335px;
                ${Tablet} {
                  max-width: 492px;
                }
                ${Desktop} {
                  max-width: 492px;
                }
              `}
            >
              <Input
                onChange={(e) => {
                  setName(e.target.value);
                }}
                errorMessage={nameError}
                placeholder={intl.formatMessage({
                  id: 'institutions.form.name',
                })}
              />
              <Input
                onChange={(e) => {
                  setCompany(e.target.value);
                }}
                errorMessage={companyError}
                placeholder={intl.formatMessage({
                  id: 'institutions.form.company',
                })}
              />
              <Input
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                errorMessage={emailError}
                placeholder={intl.formatMessage({
                  id: 'institutions.form.email',
                })}
              />
              <Input
                onChange={(e) => {
                  setPhone(e.target.value);
                }}
                errorMessage={phoneError}
                placeholder={intl.formatMessage({
                  id: 'institutions.form.phone',
                })}
              />
              <div
                css={css`
                  display: flex;
                  justify-content: center;
                  margin-top: 38px;
                `}
              >
                <Button
                  css={css`
                    width: 178px;
                    height: 47px;
                    border-radius: 41px;
                    background-color: #ee2f79;

                    font-size: 18px;
                    font-weight: bold;
                    line-height: normal;
                  `}
                  disabled={loading}
                  onClick={async () => {
                    setLoading(true);
                    resetError();
                    let error = false;
                    if (!name || name.trim() === '') {
                      error = true;
                      setNameError(errorMessages[intl.locale]['missingName']);
                    }
                    if (!company) {
                      error = true;
                      setCompanyError(
                        errorMessages[intl.locale]['missingCompany']
                      );
                    }
                    if (!email) {
                      error = true;
                      setEmailError(errorMessages[intl.locale]['missingEmail']);
                    } else if (
                      !/^[A-Z0-9._%+-]{1,30}@[A-Z0-9.-]{1,50}\.[A-Z]{2,10}$/i.test(
                        email
                      )
                    ) {
                      error = true;
                      setEmailError(errorMessages[intl.locale]['invalidEmail']);
                    }
                    if (!phone) {
                      error = true;
                      setPhoneError(errorMessages[intl.locale]['missingPhone']);
                    } else if (
                      !/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/.test(phone)
                    ) {
                      error = true;
                      setPhoneError(errorMessages[intl.locale]['invalidPhone']);
                    }
                    if (!error) {
                      const response = await Axios.post(
                        `${apiUrl}/api/v4/users/orgs/contact`,
                        {
                          type: 1,
                          name,
                          company,
                          email,
                          phone,
                        }
                      );
                      if (response.data.status.ecode) {
                        // setErrorCode(response.data.status.ecode);
                        // 原来是显示错误代码，现调整为显示错误三语信息
                        setErrorCode(
                          response.data.status[
                            `message${errorMessageMap[intl.locale]}`
                          ]
                        );
                      } else {
                        setSuccess(true);
                      }
                    }
                    setLoading(false);
                  }}
                >
                  {loading ? (
                    {
                      en: 'Submitting...',
                      'zh-cn': '提交中...',
                      'zh-hk': '提交中...',
                    }[intl.locale]
                  ) : (
                    <FormattedHTMLMessage id='institutions.form.submit' />
                  )}
                </Button>
              </div>
            </div>
          </>
        )}

        {/* <Container>
          <div
            css={css`
              width: 100%;
              height: 3px;
              background: white;
              margin-top: 30px;
            `}
          ></div>
        </Container> */}
      </div>
    </div>
  );
};
export default InstitutionsForm;
